import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CheckIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = '#FDFDFD',
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <Path
        d="M13.3333 4L5.99956 11.3338L2.66602 8.00025"
        stroke={color}
        strokeWidth={1.33342}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default CheckIcon;
